import { PdfViewer } from './PdfViewer'
import './index.styles.css'
interface Props {
  url: string
  contentType: string
}

export const ExpenseFileViewer = ({ url, contentType }: Props) => {
  const isPdf = contentType === 'application/pdf'
  const isImage = contentType.startsWith('image/')

  return (
    <>
      {isPdf && <PdfViewer url={url} initialScale="page-fit" />}

      {isImage && <img src={url} className={'ExpenseFileViewer_previewImage'} />}
    </>
  )
}
